"use client";

import { StoreBuilderSettingsForm } from "@/ui/admin/store-builder/store-builder-settings-form";
import type { YnsComponentForm } from "../types";
import type { Children } from "./children";

export const ChildrenForm: YnsComponentForm<typeof Children> = ({ data, props, theme }) => {
	if (!props.setSettings) {
		console.error(`setSettings not passed to ChildrenForm`);
		return null;
	}
	return (
		<div>
			<StoreBuilderSettingsForm settings={props.settings ?? {}} setSettings={props.setSettings} />
		</div>
	);
};
